import React, { PropsWithChildren } from 'react';

interface ButtonBaseProps {
  onClick: CallableFunction;
  disabled?: boolean;
  className?: string;
  outline?: boolean;
  type?: 'button' | 'submit' | 'reset' | undefined;
}

const ButtonBase = ({
  children,
  onClick = () => {},
  disabled = false,
  className,
  type = 'button',

}: PropsWithChildren<ButtonBaseProps>) => {

  const handleClick = () => {
    onClick()
  }

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={`
      ${className}
      ring-1
      flex rounded-full px-4 py-3 font-semibold leading-none
      items-center justify-center
      disabled:opacity-50
      disabled:pointer-events-none
      transition-color ease-in-out duration-200
      h-11
      `}
    >
      {children}
    </button>
  )
}

export default ButtonBase;